<button [ngClass]="[color, style]" [class.disabled]="disabled" [attr.type]="type || 'button'">
    <ng-content></ng-content>
    <mat-icon *ngIf="arrow" aria-hidden="true" svgIcon="minimal_arrow"></mat-icon>
</button>